import React from 'react';
import Top from '../Top';
import Results from '../Results';
import './App.scss';

const App = (props) => (
    <div className="ghg">
        {/* <header className="ghg-header">
            <h1 className="ghg-header-one">Green Power Equivalency Calculator</h1>
            <p>This calculator can help you to better communicate your green power use to interested stakeholders by translating it from kilowatt-hours (kWh) into more understandable terms and concrete examples.</p>
        </header> */}
        <Top />
        {props.showCalculations ? <Results /> : ''}
    </div>
);

export default App;



/** WEBPACK FOOTER **
 ** ./src/components/App/App.js
 **/